// extracted by mini-css-extract-plugin
export default {"cardTable":"MatchupCard_cardTable__8RvAG","cardRow":"MatchupCard_cardRow__hDw+z"};